import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OptionDropdown, SelectControl } from '../../models/OptionDropdownSelect';
import { AchTransactionDetailsForm, CheckTransactionDetailsForm, ItTransactionDetailsForm, WireTransactionDetailsForm } from '../../models/form/TransactionFormGroup';
import { TextInputModel } from '../../../shared/components/controls/text-input-control/TextInputModel';

const controlName = 'trustComment';

@Component({
  standalone: false,
  selector: 'mm-trust-comment',
  templateUrl: './trust-comment.component.html',
  styleUrls: ['./trust-comment.component.scss']
})
export class TrustCommentComponent implements OnInit, OnDestroy {
  @Input() parentForm: FormGroup<CheckTransactionDetailsForm | WireTransactionDetailsForm | ItTransactionDetailsForm | AchTransactionDetailsForm>;
  
  commentInputModel: TextInputModel = {
    controlName: controlName,
    label: 'Trustee/IA comments',
    hasGreyText: true,
    greyText: '(optional)',
    htmlMaxLength: 60
  };
 showWarning: boolean = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    if (!this.parentForm?.contains(controlName)) {
      this.parentForm?.setControl(controlName, this.fb.nonNullable.control(''));
    }
  }

  get warningData() {
    const Comment = this.parentForm?.get(controlName)?.value;
    this.showWarning = Comment !== null && Comment !== '' ? true : false;
    this.parentForm?.get(controlName)?.setValue(Comment);
    return this.showWarning;
  }
  
  ngOnDestroy(): void {
    this.parentForm?.removeControl(controlName);
  }

}
